import { colors, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

type DataCapProps = {
  dataCap: string;
  downloadSpeed: string;
};

const DataCap = ({ dataCap, downloadSpeed }: DataCapProps) => {
  const { t } = useTranslation('ChangePlan');
  const hasDownloadSpeedAndDataCap = downloadSpeed && dataCap;

  return (
    <Txt
      component="span"
      variant="bodyLargeRegular"
      style={
        hasDownloadSpeedAndDataCap
          ? {
              borderLeft: `1px solid ${colors['gray'][300]}`,
              marginLeft: '3px',
            }
          : { paddingLeft: 0 }
      }
      pl="8px"
    >
      {dataCap && t('plan.mobileHeader.updatedDataCap', { value: dataCap })}
    </Txt>
  );
};

export default DataCap;
